module.exports = __webpack_public_path__ + "static/media/pxiByp8kv8JHgFVrLCz7Z1xlFd2JQEk.25b0e113.woff2";